import { IApplicationState } from '../../types/redux';

export function getCurrentTab(state: IApplicationState) {
  return state.tab;
}
